import { Box } from '@mui/material'
import { sanitizeReplyBody } from './sanitizeReplyBody'

export default function ReplyBody({ body }) {
    return (
        <Box
            className="reply-body"
            sx={{
                overflowWrap: 'anywhere',
                '& a': { textDecoration: 'underline' },
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeReplyBody(body) }}
        />
    )
}
